'use strict'

export let norwegian_productPlan={
  general: {
    stage: "Oppdatering",
    stageMenu: {
      stageActions: "Handlinger for oppdateringen"
    },
    stagePlan: {
      title: "Plan for oppdatering",
      projectPhase: "Produkt",
    },
  },
  schedule: {
    title: "Langtidsplan",
    fields: {
      schedule: {
        columnHeaders: {
          stage: { title: "Oppdatering" },
        },
        options: {
          addEntry: { title: "+ Legg til oppdatering" }
        }
      }
    }
  },
  stageDescription: {
    title: "Oppdateringen",
    fields: {
      identifier: {
        title: 'Oppdateringsidentifikator',
        description: 'Unik idenfikator for oppdateringen'
      },
      name: {
        description: "Navn på oppdateringen"
      },
      description: {
        title: "Beskrivelse",
        help: `Hvor i produktets livssyklus er denne oppdateringen?
          Hva er målet med oppdateringen?
          Kort oppsummert, hva vil denne oppdateringen inneholde og hvordan vil det bli gjort?`,
        description: "Beskriv kort hva denne oppdateringen innebærer"
      }
    }
  },
  stageTime: {
    fields: {
      period: {
        title: "Tidsperiode for oppdateringen"
      },
      timeComments: {
        description: "Kommentarer til tidsaspektet av oppdateringen"
      }
    }
  },
  stageCost: {
    fields: {
      budget: {
        title: "Oppdateringsnes budsjett",
        help: `Timer: Antall timer som trengs av internt personale, eller timer brukt av eksterne ressurser hvor tilnærmingen er å følge opp prosjektkostanden i timer.
          Utgifter: Direkte utgifter mottatt som faktura. Dette bør normalt utelukke utgifter ført som timer. Bør ikke inkludere investeringer.
          Investeringer: Balanseførte kostnader for anleggsmidler
          Totalt: Manuelt beregnet total kostnad for oppdateringen. Vanligvis totalt = timer x timekostnad + utgifter + investeringer.`,
      }
    }
  },
  stageScheduleScope: {
    fields: {
      scheduleComments: {
        description: "Beskriv eller list opp hva som vil bli levert i dennne oppdateringen, når og av hvem"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/plan/labels/product/norwegian#productPlan.js